import { PayloadAction } from '@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { LoginSaga } from './saga';
import {
  LoginPageState,
  LoginUserModel,
  ResponseLoginUserModel,
} from './types';

export const initialState: LoginPageState = {
  processing: false,
  loginBadAttempts: 0,
};

const slice = createSlice({
  name: 'loginPage',
  initialState,
  reducers: {
    login(state, action: PayloadAction<LoginUserModel>) {
      state.processing = true;
    },
    login_Success(state, action: PayloadAction<ResponseLoginUserModel>) {
      state.processing = false;
      state.Response = action.payload;
    },
    login_Error(state, action: PayloadAction<string>) {
      state.processing = false;
      state.error = action.payload;
    },
    setProvider(state, action: PayloadAction<string | null>) {
      if (state.Response !== undefined) {
        state.Response.Provider = action.payload;
      }
    },
    increaseBadAttempts(state) {
      state.loginBadAttempts = state.loginBadAttempts + 1;
    },
    clearBadAttempts(state) {
      state.loginBadAttempts = 0;
    },
  },
});

export const { actions: loginActions } = slice;

export const useLoginSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: LoginSaga });
  return { actions: slice.actions };
};
